import { render, staticRenderFns } from "./ASorSectionList.vue?vue&type=template&id=911074b8"
import script from "./ASorSectionList.vue?vue&type=script&lang=js"
export * from "./ASorSectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports